import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Visible = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Show",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M12 5.496a11 11 0 0 1 9.8 6.004l.2.5-.2.5a11 11 0 0 1-19.6 0L2 12l.2-.5A11 11 0 0 1 12 5.496M3.1 12a9.8 9.8 0 0 0 8.9 5.5 9.8 9.8 0 0 0 8.9-5.5A9.8 9.8 0 0 0 12 6.5 9.8 9.8 0 0 0 3.1 12M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 0 0 3 3 2.9 2.9 0 0 0 3-3 3 3 0 1 0-6 0"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
